import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { WindowLoadingIndicator } from '@tfecom-thermofisher/react-komodo-design';

import withLoader from 'src/core/components/withLoader';

const Loading = ({ isLoaderVisible }) => {
  if (!isLoaderVisible) {
    return null;
  }

  return createPortal(
    <div className="loader-wrapper">
      <WindowLoadingIndicator isLoading />
    </div>,
    document.getElementById('loader')
  );
};

Loading.propTypes = {
  isLoaderVisible: PropTypes.bool.isRequired,
};

export default withLoader(Loading);
